import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { UserService } from 'src/app/core/services/user.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { GenericLabelValue } from 'src/app/shared/models/DTO/GenericLabelValue.dto';
import { LaborScheduleItem, LaborScheduleStatus } from 'src/app/shared/models/laborScheduling/LaborScheduling.model';

@Component({
	selector: 'app-employee-schedule-list',
	templateUrl: './employee-schedule-list.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class EmployeeScheduleListComponent implements OnInit, OnDestroy {
	subscriptionList: Subscription = new Subscription();

	laborScheduleList: LaborScheduleItem[];

	statusList: GenericLabelValue[] = [];

	constructor(
		public app: AppService,
		public venueService: OOVenueService,
		private focuslink: FocuslinkService,
		private router: Router,
		public userService: UserService
	) {}

	ngOnDestroy(): void {
		this.subscriptionList.unsubscribe();
	}

	ngOnInit(): void {
		if (this.venueService.employeeList.value.length === 0) {
			this.venueService.employeeListGet(this.venueService.subscriptionVenue.value.key);
		}

		Object.keys(LaborScheduleStatus).forEach((key) => {
			if (isNaN(+key)) {
				this.statusList.push({
					label: key,
					value: LaborScheduleStatus[key],
				});
			}
		});

		this.getLaborSchedule(this.venueService.subscriptionVenue.value.key);
	}

	async getLaborSchedule(venueKey: number) {
		const resp = await this.focuslink.laborScheduleGetAll(this.venueService.subscriptionVenue.value.key);
		this.laborScheduleList = resp.map((i) => new LaborScheduleItem(i));
	}

	new() {
		this.router.navigate(['/cc/employees/schedules/new-schedule']);
	}

	select(laborSchedule: LaborScheduleItem) {
		this.router.navigate([`/cc/employees/schedules/${laborSchedule.externalId}`]);
	}
}
